import { Box, Typography } from "@mui/material";
import { BsCalculator } from "react-icons/bs";
import { FaChevronDown } from "react-icons/fa6";
import CloseIcon from '@mui/icons-material/Close';
import AppMobileBottomNavContainer from "../AppMobileBottomNavContainer";
import RiskScoreCalculatorForm from "../RiskScoreCalculatorForm";

const RiskScoreCalculatorMobileNav = ({ isOpened, setIsOpened }) => {
  return (
    <AppMobileBottomNavContainer
      isOpen={isOpened}
      setIsOpen={setIsOpened}
      sx={{
        padding: 0
      }}
    >
      <Box
        sx={{
          height: '64px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          borderBottom: '1px solid',
          borderColor: 'primary.lightGray',
          bgcolor: 'background.default',
          padding: '8px 20px',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center'
          }}
        >
          <BsCalculator
            color="#5B87EF"
            size={20}
          />
          <Typography variant="h4" ml='4px' mt='2px'>
            Risk Score Calculator
          </Typography>
        </Box>
        <Box
          onClick={() => setIsOpened(!isOpened)}
        >
          {isOpened ? (
            <CloseIcon 
              sx={{
                fontSize: '28px',
                color: 'primary.mediumGray',
                cursor: 'pointer'
              }}
            />
          ) : (
            <FaChevronDown 
              color="#46545F"
              size={22}
              cursor="pointer"
            />
          )}
        </Box>
      </Box>
      <RiskScoreCalculatorForm />
    </AppMobileBottomNavContainer>
  )
}

export default RiskScoreCalculatorMobileNav